const live = {
    getDetail: { api: '/api.php/Live/getDetail', },
    getLists: { api: '/api.php/Live/getLists', },
    getVideoLists: { api: '/api.php/Live/getVideoLists', },
    checkLoading: { api: '/api.php/Live/checkLoading', },
    getHistoryLists: { api: '/api.php/Live/getHistoryLists', },
    getCommentLists: { api: '/api.php/Live/getCommentLists', },
}
export default live
